import React, {
    useContext,
} from 'react';
import { Link } from 'react-router-dom';

import * as routes from '../../constants/routes';
import {
    POL_THEME,
    ThemeContext,
} from '../../constants/theme.ts';

import styles from './Footer.scss';

const Footer = () => {
    const themeContext = useContext(ThemeContext);

    return (
        <div className={styles.footerContainer}>
            <footer className={styles.footer}>
                <nav className={styles.menuContainer}>
                    {themeContext === POL_THEME ? (
                        <>
                            <ul className={styles.menu}>
                                <li><Link to={routes.ADVERTISE}>Advertise</Link></li>
                                <li><Link to={routes.ABOUT}>About</Link></li>
                                <li>
                                    <a
                                        href="https://www.4lpi.com/Blog/"
                                        rel="noreferrer"
                                        target="_blank"
                                    >
                                        Blog
                                    </a>
                                </li>
                                <li><Link to={routes.HELP}>Help</Link></li>
                                <li>
                                    <a
                                        href="https://www.4lpi.com/privacy-policy/"
                                        rel="noreferrer"
                                        target="_blank"
                                    >
                                        Privacy
                                    </a>
                                </li>
                                <li><Link to={routes.TERMSCONDITIONS}>Terms</Link></li>
                            </ul>
                            <p>
                                Powered by LPi &copy;
                                {(new Date().getFullYear())}
                            </p>
                        </>
                    ) : (

                        <>
                            <ul className={styles.menuMCO}>
                                <li><Link to={routes.ADVERTISE}>Advertise</Link></li>
                                <li><Link to={routes.ABOUT}>About</Link></li>
                                <li><Link to={routes.HELP}>Help</Link></li>
                                <li>
                                    <a
                                        href="https://www.4lpi.com/privacy-policy/"
                                        rel="noreferrer"
                                        target="_blank"
                                    >
                                        Privacy
                                    </a>
                                </li>
                                <li><Link to={routes.TERMSCONDITIONS}>Terms</Link></li>
                            </ul>
                            <p className={styles.powered}>
                                Powered by LPi &copy;
                                {(new Date().getFullYear())}
                            </p>
                        </>
                    )}
                </nav>
            </footer>
        </div>
    );
};

export default Footer;
